import { render, staticRenderFns } from "./SystemMessageModal.vue?vue&type=template&id=711351c0"
import script from "./SystemMessageModal.vue?vue&type=script&lang=js"
export * from "./SystemMessageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports